import React from 'react';
import AcceptedOffers from './AcceptedOffers';
import UserCallouts from './UserCallouts';
import ManageWorkspaces from './ManageWorkspaces';
import RestoreActivity from './RestoreActivity';
import StripeTesting from './StripeTesting';
import LIIntegrationVersion from './LIIntegrationVersion';
import DeleteCardDav from './DeleteCardDav';

export default function StagingSettingsPanel() {
  return (
    <>
      <AcceptedOffers />
      <UserCallouts />
      <ManageWorkspaces />
      <RestoreActivity />
      <StripeTesting />
      <LIIntegrationVersion />
      <DeleteCardDav />
    </>
  );
}
